import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './InfoMessage.module.css'
import Button from '../Button/Button'
import { newlineToBr } from '../../utils/format' 

import FormActions from '../../actions/FormActions'

export default class InfoMessage extends Component {
  static propTypes = {
    instructions: PropTypes.string,
    message: PropTypes.string
  }
  static defaultProps = {
    instructions: '',
    message: ''
  }
  _onClick () {
    FormActions.setShowInfoMessage(false)
  }

  render () {
    const { instructions, message } = this.props
    if (!message) return null
    return (
      <div className={styles.infoMessage}>
        <div className={styles.message}>
          <img src={'/static/img/info.png'} className={styles.image} />
          {instructions && <div>
            <p dangerouslySetInnerHTML={{ __html: newlineToBr(instructions) }} className={styles.instructions} />
            <hr />
          </div>}
          <p dangerouslySetInnerHTML={{ __html: newlineToBr(message) }} className={styles.text} />
          <Button
            autoFocus
            onClick={this._onClick.bind(this)}
            text="Jag förstår" />
        </div>
      </div>
    )
  }
}
